import { useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useMaintenance } from '../../contexts/MaintenanceContext';
import { progressApi } from '../../api/progress';
import { acknowledgeOfflineAdhkar, OFFLINE_ADHKAR_CHANGED, OFFLINE_ADHKAR_SYNCED, pendingOfflineAdhkar } from '../../services/offlineAdhkarProgress';

export default function OfflineAdhkarSync() {
  const { currentUserId, loading } = useAuth();
  const { online, blocked, checking, error } = useMaintenance();
  useEffect(() => {
    if (!currentUserId || loading || !online || blocked || checking || error) return undefined;
    let stopped = false, running = false, timer, delay = 15000;
    const schedule = (ms = 1500) => { clearTimeout(timer); if (!stopped) timer = setTimeout(sync, ms); };
    async function sync() {
      if (stopped || running || navigator.onLine === false) return;
      running = true;
      try {
        const days = await pendingOfflineAdhkar(currentUserId);
        if (!days.length || stopped) return;
        const result = await progressApi.syncOfflineAdhkar({ accountId: currentUserId, days });
        if (stopped) return;
        await acknowledgeOfflineAdhkar(currentUserId, days);
        window.dispatchEvent(new CustomEvent(OFFLINE_ADHKAR_SYNCED, { detail: { accountId: currentUserId, ...result } }));
        delay = 15000;
        schedule();
      } catch {
        if (!stopped) { schedule(delay); delay = Math.min(delay * 2, 300000); }
      } finally { running = false; }
    }
    const changed = () => schedule();
    const visible = () => { if (document.visibilityState === 'visible') schedule(0); };
    void sync();
    window.addEventListener(OFFLINE_ADHKAR_CHANGED, changed);
    document.addEventListener('visibilitychange', visible);
    return () => { stopped = true; clearTimeout(timer); window.removeEventListener(OFFLINE_ADHKAR_CHANGED, changed); document.removeEventListener('visibilitychange', visible); };
  }, [currentUserId, loading, online, blocked, checking, error]);
  return null;
}
